import React from 'react';
import styled from 'styled-components';
import {ReactComponent as DOCXIcon} from 'assets/icons/file-icon-docx.svg';
import {ReactComponent as PDFIcon} from 'assets/icons/file-icon-pdf.svg';
import {ReactComponent as PPTIcon} from 'assets/icons/file-icon-ppt.svg';
import {ReactComponent as TXTIcon} from 'assets/icons/file-icon-txt.svg';
import {ReactComponent as VideoIcon} from 'assets/icons/file-icon-video.svg';


const IconHolder = styled.div`
  padding: 13px;
  background-color: rgba(209,212,220, 0.5);
  border-radius: 10px;
  width: 24px;
  height: 24px;
`;

const ImagePreview = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 10px;
`

const FileIcon = ({attachment}) => {
    let attachmentType = attachment.type;
    return (
        <>
            { attachmentType === "png" || attachmentType==="jpg" || attachmentType==="jpeg" || attachmentType==="png" ? (
                <ImagePreview src={attachment.publicUrl}></ImagePreview>)
                :
                (
                <IconHolder>
                    {attachmentType === "png"   && <ImagePreview/>}
                    {attachmentType === "jpg"   && <ImagePreview/>}
                    {attachmentType === "jpeg"   && <ImagePreview/>}
                    {attachmentType === "docx"  && <DOCXIcon fill="#42526E"/>}
                    {attachmentType === "pdf"   && <PDFIcon fill="#42526E"/>}
                    {attachmentType === "ppt"   && <PPTIcon fill="#42526E"/>}
                    {attachmentType === "txt"   && <TXTIcon fill="#42526E"/>}
                    {(attachmentType === "mp4"||attachmentType === "mov"||attachmentType === "video") && <VideoIcon fill="#42526E"/>}
                </IconHolder>
                )
            }
        </>
    );
};

export default FileIcon;